import { campaignImpression, campaignClick } from "../../../Analytics/campaigns.js";
import { CRITEO_INTERSECTION_THRESHOLD, CRITEO_TIME_DELAY_IN_MS } from "../constants.js";
function isCommerceFlagshipFormat(format) {
  const lowerCaseFormat = format ? format.toLowerCase() : "";
  return lowerCaseFormat === "fs" || lowerCaseFormat === "custom_multilanguagescanadafs";
}
function getLocalizedCriteoRenderingValue(rendering, key, locale) {
  let value;
  if ((locale == null ? void 0 : locale.toLowerCase()) === "fr-ca") {
    value = rendering == null ? void 0 : rendering[key + "_french"];
  }
  if (!value) {
    value = rendering == null ? void 0 : rendering[key];
  }
  return value;
}
function useCriteoAnalytics({
  placement,
  products
}) {
  const sendBeacon = (beacon) => {
    if (beacon) {
      navigator.sendBeacon(beacon);
    }
  };
  const getProduct = (itemNumber) => {
    if (products) {
      return products == null ? void 0 : products.find(
        ({ ParentSKU, ProductId }) => ParentSKU === itemNumber || ProductId === itemNumber
      );
    }
  };
  const onTileAction = (itemNumber, beaconType) => {
    const product = getProduct(itemNumber);
    if (product) sendBeacon(product == null ? void 0 : product[beaconType]);
  };
  const onCarouselRendered = () => {
    if (placement) {
      sendBeacon(placement.OnLoadBeacon);
    }
  };
  const onCarouselViewed = () => {
    if (placement) {
      sendBeacon(placement.OnViewBeacon);
      campaignImpression(placement, "Criteo");
    }
  };
  const onBannerClicked = () => {
    console.log("onBannerClicked");
    if (placement) {
      sendBeacon(placement.OnClickBeacon);
      campaignClick(placement, "Criteo");
    }
  };
  const onBundleBasketChangeBeacon = () => {
    if (placement) sendBeacon(placement.OnBundleBasketChangeBeacon);
  };
  const onBannerFileClicked = () => {
    if (placement) {
      sendBeacon(placement.OnFileClickBeacon);
      campaignClick(placement, "Criteo");
    }
  };
  const onTileLoad = (itemNumber) => onTileAction(itemNumber, "OnLoadBeacon");
  const onTileViewed = (itemNumber) => {
    onTileAction(itemNumber, "OnViewBeacon");
    campaignImpression(placement, "Criteo");
  };
  const onTileClicked = (itemNumber) => {
    onTileAction(itemNumber, "OnClickBeacon");
    campaignClick(placement, "Criteo", itemNumber);
  };
  return {
    minimumViewTime: CRITEO_TIME_DELAY_IN_MS,
    onBannerClicked,
    onBannerFileClicked,
    onBundleBasketChangeBeacon,
    onCarouselRendered,
    onCarouselViewed,
    onTileClicked,
    onTileLoad,
    onTileViewed,
    viewThreshold: CRITEO_INTERSECTION_THRESHOLD
  };
}
export {
  getLocalizedCriteoRenderingValue,
  isCommerceFlagshipFormat,
  useCriteoAnalytics
};
